import React, { useEffect, useState } from "react";
import heroImg from '../../assets/Banner.png';
import BookingForm from "../common/BookingForm";
import { FaCheck } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";



const About = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>The Best Cab Jaipur – One Way Taxi, Round Trips & Tour Services</title>
        <meta
          name="description"
          content="Book affordable cab service in Jaipur for one-way, round-trip, and outstation travel. Explore India’s top destinations with our trusted tour packages."
        />
        <meta
          name="keywords"
          content="Jaipur cab service, one way taxi Jaipur, round trip taxi Jaipur, outstation travel, affordable taxi service, India tour packages, Jaipur sightseeing, trusted tour services"
        />
      </Helmet>
      <div className="relative w-full min-h-screen mt-[70px] bg-gray-50">
        {/* Hero Section */}
        <section className="relative  h-[30vh] sm:h-[60vh] w-full">
          <img
            src={heroImg}
            alt="About Hero"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-pink-600/80 to-pink-500/80"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full text-white px-4 sm:px-10 md:px-20 text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold font-serif">About The Best Cab</h1>
            <p className="text-lg sm:text-xl md:text-2xl mt-4 max-w-3xl">
              Your trusted partner for cab services, tours & hotel bookings across India
            </p>
          </div>
        </section>

        {/* About Content */}
        <section className="py-16 px-6 sm:px-12 md:px-20 max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-pink-600 mb-4">Welcome to The Best Cab</h2>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto">
              Your one-stop destination for cab booking, tour packages, hotel stays, and guided sightseeing tours across India.
              Whether you're looking for a taxi service in Jaipur, planning an outstation trip, or need a professional tour guide,
              we provide seamless travel solutions designed for your comfort and convenience.
            </p>
          </div>

          {/* Who We Are */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
            <h3 className="text-2xl font-bold text-pink-600 mb-6 pb-2 border-b-2 border-blue-200">Who We Are?</h3>
            <p className="text-gray-700 mb-6">
              As a leading name in the travel and tourism industry, we specialize in offering affordable taxi services,
              customized tour packages, hotel bookings, and sightseeing experiences in Jaipur and throughout India.
              Our goal is to make every journey memorable with top-quality service, professional drivers, and expert tour guides.
            </p>
          </div>

          {/* Services Section */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-center text-pink-600 mb-8">Our Services</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8  ">
              {[
                "Local & Outstation Taxi Services – Book a cab near you for city travel or long-distance journeys.",
                "Airport Transfers – Reliable airport taxi service with on-time pickup and drop.",
                "Hotel Booking – Comfortable and budget-friendly stays at top-rated hotels.",
                "Tour Guide Services – Explore India's rich history with experienced guides.",
                "Sightseeing Packages – Discover famous landmarks and hidden gems.",
                "Customized Tour Packages – Tailored experiences across India for solo travelers, families, and groups.",

              ].map((service, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-pink-600">
                  <div className="flex items-start">
                    <span className="text-pink-500 mr-3 mt-1"><FaCheck className="" />
                    </span>
                    <p className="text-gray-700">{service}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="bg-pink-600 rounded-xl p-8 text-white mb-16">
            <h3 className="text-2xl font-bold mb-6 pb-2 border-b-2 border-blue-300">Why Choose Us?</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  title: "Affordable Pricing",
                  desc: "No hidden charges, only fair fares."
                },
                {
                  title: "Reliable Services",
                  desc: "Well-maintained fleet and trained professionals."
                },
                {
                  title: "Easy Booking",
                  desc: "Quick and convenient taxi & tour booking."
                },
                {
                  title: "Trusted Travelers",
                  desc: "Thousands of satisfied customers across India."
                }
              ].map((item, index) => (
                <div key={index} className="bg-white/10 p-6 rounded-lg backdrop-blur-sm">
                  <h4 className="text-xl font-semibold mb-2">{item.title}</h4>
                  <p className="text-blue-100">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <p className="text-lg text-gray-700 mb-8">
              At The Best Cab, we are committed to delivering the best taxi service in Jaipur and beyond,
              ensuring smooth and enjoyable travel experiences.
            </p>
            <button

              className="px-8 py-4 bg-gradient-to-r from-pink-600 to-pink-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all font-bold text-lg inline-block"
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(true);
              }}
            >
              Book Your Ride, Hotel, or Tour Today!
            </button>
            <BookingForm isOpen={isOpen} setIsOpen={setIsOpen} />
          </div>
        </section>

      </div>
    </>
  );
};
export default About;